import React, { Component } from "react"
import { Field, reduxForm } from "redux-form"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { userLogin } from "../actions"
import { Col, Panel, Row, Button, Modal } from 'react-bootstrap'
import _ from 'lodash'
import NavHeader from './navheader'
import SubMenu from './submenu'
import Footer from './footer'
import { nearestRoads } from "@google/maps/lib/apis/roads";
import MetaTags from 'react-meta-tags'

const normalizePhone = value => {
    const onlyNums = value.replace(/[^\d]/g, '')
    return onlyNums
}

class PageLogin extends Component {

    state = {
        showPassword: false,
        loading: false,
        showerrmodal: false
    }

    componentWillMount() {
        if (localStorage.getItem('user') != null) {
            this.props.history.push('/user_info')
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user) {
            this.setState({ loading: false })
        }
        if (!_.isEmpty(nextProps.user) && this.props.user != nextProps.user && nextProps.user.success == true) {
            let user_info = nextProps.user.data
            user_info['token'] = nextProps.user.token
            localStorage.setItem('user', JSON.stringify(user_info))
            // window.Intercom('shutdown')
            // window.Intercom('boot', {
            //     app_id: 'j77n0bkz',
            //     user_id: user_info.phone_number,
            //     name: user_info.name + ' ' + user_info.lastname,
            // });
            if (!_.isEmpty(JSON.parse(localStorage.getItem('cart_products')))) {
                this.props.history.push('/order_review')
            } else {
                this.props.history.push('/')
            }
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    renderField(field) {
        const { meta: { touched, error } } = field;
        const className = `form-group ${touched && error ? "has-danger" : ""}`;
        return (
            <div className={className}>
                <input placeholder={field.placeholder} className="form-control" type={field.type} {...field.input} />
                <div className="text-help">
                    {touched ? error : ""}
                </div>
            </div>
        )
    }

    callbackerr() {
        this.setState({ showerrmodal: true, loading: false })
    }

    onSubmit(values) {
        this.setState({ loading: true })
        this.props.userLogin(values, this.callbackerr.bind(this))
    }

    onRegister() {
        this.props.history.push('/register')
    }

    render() {
        // this.props.invalid && this.props.pristine ? console.log('metatags') : ''
        const { handleSubmit } = this.props
        let isLoading = this.state.loading

        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                {
                    this.props.invalid && this.props.pristine
                        ? <MetaTags>
                            <title>{'ส่งสด - บริการส่งของสดจากตลาด'}</title>
                            <meta property="og:title" content={'ส่งสด บริการส่งของสด'} />
                            <meta property="og:url" content={window.location.href} />
                            <meta property="og:image" content={'imgsrc'} />
                            <meta property="og:description" content={'บริการส่งของสดจาก ตลาดยิ่งเจริญ ที่คัดสรรคุณภาพของวัตถุดิบโดยผู้ซื้อสินค้าส่วนตัว'} />
                            <meta property="og:type" content='website' />
                            <meta property="fb:pages" content="129193147647837" />
                        </MetaTags> : ''
                }
                <div className="container main-bg" style={{ height: '700px' }}>
                    <Col md={3} sm={1} xs={0}>
                    </Col>
                    <Col md={6} sm={10} xs={12}>
                        <div style={{ padding: '10px', textAlign: 'center', marginTop: 25 }}>
                            <img src="../../static/images/logo_songsod_blue.png" style={{ width: '20%' }} />
                        </div>
                        <Panel style={{ backgroundColor: '#fafafa' }}>
                            <div className="section-message">
                                <h3 className="section-message-content">เคยลงทะเบียนแล้ว ?</h3>
                            </div>
                            <form onSubmit={handleSubmit(this.onSubmit.bind(this))} >
                                <small>เบอร์โทรศัพท์</small>
                                <Field
                                    placeholder="กรุณากรอกเบอร์โทรศัพท์"
                                    name="phone_number"
                                    type='text'
                                    component={this.renderField}
                                    normalize={normalizePhone}
                                />
                                <small>รหัสผ่าน</small>
                                <Field
                                    placeholder="กรุณากรอกรหัสผ่าน" 
                                    name="password"
                                    type={this.state.showPassword ? 'text' : 'password'}
                                    component={this.renderField}
                                />

                                <a style={{ float: 'right', marginBottom:15 }} href={'/forget_password'}>ลืมรหัสผ่าน?</a>

                                <button type="submit" className="btn btn-success max-width"
                                    disabled={this.state.loading}
                                // onClick={!this.state.loading ? this.onSubmit.bind(this) : null}>
                                >
                                    {this.state.loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
                                </button>
                                <h5 style={{ textAlign: 'center' }}>หรือ</h5>
                            </form>
                            <div className="section-message">
                                <h3 className="section-message-content">คุณยังไม่มีบัญชีของ ส่งสด.com ใช่หรือไม่ ?</h3>
                            </div>
                            <button className='btn btn-success max-width' onClick={this.onRegister.bind(this)}>ลงทะเบียน</button>

                        </Panel>
                    </Col>
                </div>
                <Footer history={this.props.history} />
                <Modal show={this.state.showerrmodal} onHide={() => { this.setState({ showerrmodal: false }) }}>
                    <Modal.Header closeButton>
                        <Modal.Title>มีข้อผิดพลาด</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ textAlign: 'center' }}>
                        กรุณาตรวจสอบ Username และ Password
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle="primary" onClick={() => { this.setState({ showerrmodal: false }) }}>ตกลง</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user_reducer
    }
}

function validate(values) {
    const errors = {}
    if (!values.phone_number) {
        errors.phone_number = 'กรุณาใส่เบอร์โทรศัพท์'
    }
    if (!values.password) {
        errors.password = 'กรุณาใส่รหัสผ่าน'
    }
    return errors;
}
export default reduxForm({
    validate,
    form: "LoginForm"
})(connect(mapStateToProps, { userLogin })(PageLogin))


// WEBPACK FOOTER //
// ./src/components/page_login.js